// extracted by mini-css-extract-plugin
export default {"updateNowFooter":"UpmeUpdateNowFooter_updateNowFooter__m696U","subtitle":"UpmeUpdateNowFooter_subtitle__CoFC3","button":"UpmeUpdateNowFooter_button__LPNPE"};